import React, { useLayoutEffect, useState } from 'react'

import OpenModal from 'src/components/OpenModal'
import useWidth from 'src/hooks/window/useWidth'

import Dollar from 'inter-frontend-svgs/lib/orangeds/MD/dollar'
import LightOn from 'inter-frontend-svgs/lib/orangeds/MD/light-on'
import Services from 'inter-frontend-svgs/lib/orangeds/MD/services'
import Smartphones from 'inter-frontend-svgs/lib/orangeds/MD/smartphones'
import { IconProps } from 'src/components/Layout/Footer/Footer.interface'
import useDataLayer from 'src/hooks/useDataLayer/dataLayerBody'
import { orange } from 'src/styles/colors'

import { WIDTH_MD } from 'src/styles/breakpoints'
import DataJson from './assets/data/data.json'

import * as S from './style'
interface ICard {
  icon: string;
  title: string;
  description: string;
}

const PorqueNaoCobramosTarifas = () => {
  const [ isMobile, setIsMobile ] = useState(true)
  const [ sendDatalayerEvent ] = useDataLayer()
  const url = 'https://inter-co.onelink.me/Qyu7/jzd1g4bo'

  const width = useWidth(300)

  const data: ICard[] = DataJson

  const icons: IconProps = {
    smartphones: <Smartphones color={orange.extra} width={24} height={24} />,
    lightOn: <LightOn color={orange.extra} width={24} height={24} />,
    services: <Services color={orange.extra} width={24} height={24} />,
    dollar: <Dollar color={orange.extra} width={24} height={24} />,
  }

  useLayoutEffect(() => {
    setIsMobile(width < WIDTH_MD)
  }, [ width ])

  return (
    <S.ContentHeader className='bg-grayscale--100'>
      <div className='container'>
        <div className='row align-items-center'>
          <div className='col-12 col-md-6 col-lg-5'>
            <h2 className='fs-24 lh-30 fs-lg-32 lh-lg-40 fs-xl-48 lh-xl-50 text-grayscale--500 mb-3'>
              Por que não <span className='d-md-block'>cobramos mensalidade?</span>
            </h2>
            <p className='fs-14 lh-17 fs-lg-16 lh-lg-20 fs-xl-18 lh-xl-22 text-grayscale--400 mb-0'>
              O nosso objetivo é fazer diferente e simplificar a vida dos nossos usuários com soluções reais.
              <br />
              E por isso, criamos a primeira conta digital e gratuita do Brasil. Como isso é possível? A gente explica.
            </p>
            {!isMobile &&
              <div className='btn-div'>
                <OpenModal to='open-your-account-form'>
                  <button
                    className='btn btn-orange--extra btn--lg rounded-2 fs-14 fw-600 text-none mb-0 mw-100'
                    title='Abra sua conta'
                    onClick={() => {
                      sendDatalayerEvent({
                        section: 'dobra_09',
                        section_name: 'Por que não cobramos mensalidade?',
                        element_action: 'click button',
                        element_name: 'Abra sua conta',
                      })
                    }}
                  >
                    Abra sua conta
                  </button>
                </OpenModal>
              </div>
            }
          </div>
          <div className='col-12 col-md-6 offset-lg-1'>
            <S.CardContainers>
              {data.map((card: ICard) => (
                <S.Card key={card.icon} className='d-flex align-items-center'>
                  <div className='mr-3' style={{ marginBottom: 45 }}>
                    {icons[card.icon]}
                  </div>
                  <div>
                    <h3 dangerouslySetInnerHTML={{ __html: card.title }} className='fs-16 lh-20 fs-lg-18 lh-lg-25 fw-600 font-sora text-grayscale--500 mb-2' />
                    <p dangerouslySetInnerHTML={{ __html: card.description }} className='fs-14 lh-17 fs-lg-16 lh-lg-20 fw-400 text-grayscale--500 mb-0' />
                  </div>
                </S.Card>
              ))}
            </S.CardContainers>
            { isMobile &&
              <div className='btn-div'>
                <S.Link
                  href={url}
                  title='Abra sua conta'
                  className='btn btn-orange--extra btn--lg rounded-2 fs-14 fw-600 text-none mb-0 mw-100'
                  onClick={() => {
                      sendDatalayerEvent({
                        section: 'dobra_09',
                        section_name: 'Por que não cobramos mensalidade?',
                        element_action: 'click button',
                        element_name: 'Abra sua conta',
                        redirect_url: url,
                      })
                  }}
                >
                  Abra sua conta
                </S.Link>
              </div>
            }
          </div>
        </div>
      </div>
    </S.ContentHeader>
  )
}

export default PorqueNaoCobramosTarifas
